<template>
    <div style="width: 100%; text-align: center" data-test="nav-languages">
        <el-link data-test="nav-lang-fr" :class="languageStyle" @click="changeLanguage('fr')">Français</el-link>
        <el-link data-test="nav-lang-en" :class="languageStyle" @click="changeLanguage('en')">English</el-link>
        <el-link data-test="nav-lang-es" :class="languageStyle" @click="changeLanguage('es')">Español</el-link>
    </div>
</template>

<script>
import i18next from 'i18next'
import store from '../store'
import { getOfferTypes } from '../services/postsData'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'Languages',
  props: {
    userConnected: Boolean
  },
  computed: {
    ...mapGetters(['isImmo']),
    languageStyle () {
      return this.userConnected ? 'connected' : 'notConnected'
    }
  },
  methods: {
    ...mapActions(['setLanguage', 'setOfferTypes']),
    async changeLanguage (lang) {
      // remove the list of categories stored in portals.js->chargerCategories()
      // in order to load them in the correct language when necessary
      this.removeCategoriesInStorage()

      // change language and reload the page
      await i18next.changeLanguage(lang)
      this.setLanguage(lang)

      if (this.isImmo) {
        await getOfferTypes()
      }

      location.reload()
    },
    removeCategoriesInStorage () {
      if (this.userConnected) {
        // possible like this here because we are connected
        store.commit('donnees/SET_CATEGORY_PORTALS', null)
      }
    }
  }
}
</script>

<style scoped>
    .notConnected {
        color: white !important;
        text-decoration-color: white !important;
        margin: 0px 5px;
        font-weight: 400 !important;
    }

    .connected {
        margin: 0px 5px;
        font-weight: 400 !important;
    }
</style>
